module.exports = __webpack_public_path__ + "static/media/ipad_pro.8f1290f4.jpg";